  <div class="settings-button-block">
    <button *ngIf="isCreateEdgeShown() === true"
      (click)="createEdge()"  data-action="createEdge"
      class="button-icon size-m icononly white-button shadow-m" >
      <mat-icon class="accent-icon"  svgIcon="links-fill"></mat-icon>
    </button>
    <button *ngIf="isCreateNodeShown() === true"
      (click)="createNode()"  data-action="createNode"
      class="button-icon size-m icononly white-button shadow-m" >
      <mat-icon class="accent-icon size-xl"  svgIcon="add-box-line"></mat-icon>
    </button>
    <button *ngIf="this.isDeleteNodeShown() === true"
      (click)="deleteNode()"  data-action="deleteNode"
      class="button-icon size-m icononly white-button shadow-m" >
      <mat-icon class="accent-icon size-xl"  svgIcon="delete-bin-5-line"></mat-icon>
    </button>
    <button *ngIf="isViewNodeShown() === true"
      (click)="viewNode()"  data-action="viewNode"
      class="button-icon size-m icononly white-button shadow-m" >
      <mat-icon class="accent-icon" svgIcon="eye-line"></mat-icon>
    </button>
    <button *ngIf="isEditNodeShown() === true"
      (click)="editNode()"  data-action="editNode"
      class="button-icon size-m icononly white-button shadow-m">
      <mat-icon class="accent-icon" svgIcon="edit-line"></mat-icon>
    </button>
  </div>